// Shared CSRF token lookup — previously copy-pasted as a private
// _csrfToken() method across a dozen Stimulus controllers.
export function csrfToken() {
    const el = document.querySelector("meta[name='csrf-token']")
    return el ? el.getAttribute("content") : ""
}
